
import { Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges } from '@angular/core';
import {Router, ActivatedRoute} from "@angular/router";
import * as moment from 'moment';
import {getFiltersOffice} from '../../../../globals';

@Component({
  selector: 'services-search',
  templateUrl: '../../templates/partials/search-services.html'
})
export class SearchServicesComponent implements OnInit, OnChanges{

    public filterCity:Array<string> = [];
    public idInput:string;
    public unassigned: any = null;
    @Input() search;
    @Input() cleanFilter;
    @Output() filter = new EventEmitter();
    @Output() filterAssigned = new EventEmitter();
    @Output() searchEmitter = new EventEmitter();
    @ViewChild('dateFrom') dateFrom;
    @ViewChild('dateSince') dateSince;
    public offices: Array<object>;
    public filterAllActive: boolean = false;
    public service = {
        serviceCode: null,
        userName: null,
        cleanerName: null,
        clientName: null,
        phoneContactPerson: null,
        emailContactPerson: null,
        streetName: null,
        address: null,
        dateIni: null,
        dateEnd: null,
    };

    constructor(private _router: Router){}

    public closeSibiling(event){
        if(event == "desde"){
            this.dateSince.opened = false;
        }else if(event == "hasta"){
             this.dateFrom.opened = false;
        }
    }

    public searchServices() {
        
        var dateMin = (this.dateFrom.dt != null) ? moment(this.dateFrom.dt).format("YYYY-MM-DD") : '';
        var dateMax = (this.dateSince.dt != null) ?  moment(this.dateSince.dt).format("YYYY-MM-DD") : '';
        var object = {
            serviceCode: (this.service["serviceCode"]) ? this.service["serviceCode"] : '',
            clientName: (this.service["clientName"]) ? this.service["clientName"] : '',
            cleanerName: (this.service["cleanerName"]) ? this.service["cleanerName"] : '',
            email: (this.service["emailContactPerson"]) ? this.service["emailContactPerson"] : '',
            streetName: (this.service["streetName"]) ? this.service["streetName"] : '',
            dateMin: dateMin,
            dateMax: dateMax
        }
        if(object["serviceCode"] == '') delete object["serviceCode"];
        if(object["clientName"] == '') delete object["clientName"];
        if(object["cleanerName"] == '') delete object["cleanerName"];
        if(object["email"] == '') delete object["email"];
        if(object["streetName"] == '') delete object["streetName"];
        if(object["dateMin"] == '') delete object["dateMin"];
        if(object["dateMax"] == '') delete object["dateMax"];
        this.searchEmitter.emit(object);
    }
    
    public setFilterCity(city:string) {
        let isInArray = false;
        if(city == "all" || this.filterAllActive) {
            this.filterCity = [];
        }
        if(this.filterCity != null){
            for (var index = 0; index < this.filterCity.length; index++) {
                var element = this.filterCity[index];
                if(city == element){
                    isInArray = true;
                    this.filterCity.splice(index,1);
                    break;
                }
            }
        }
        if(this.filterAllActive && city == "all"){ 
            isInArray = true; 
        }
        if(!isInArray){
            this.filterCity.push(city);
        }
        if(!this.filterAllActive && city == "all") this.filterAllActive = true;
        else this.filterAllActive = false
        this.filterCity = this.filterCity.slice();
        this.filter.emit(this.filterCity);
    }

    public setOvalsActive(acronym: string) {
        
        if(this.filterCity != null && this.filterCity.length > 0){
            for (var index = 0; index < this.filterCity.length; index++) {
                var element = this.filterCity[index];
                if(acronym == element){ 
                    return 'c-oval--oval-active';
                }
            }
        }else return '';
    }

    public goNewService() {
        this._router.navigateByUrl('/new-service');
    }

    public filterByAssignment(event) {
        //console.log(this.unassigned);
        var data = (this.unassigned) ? 1 : null;
        this.filterAssigned.emit(data);
    }

    public emptyFilters(){
        this.filterCity = [];
        this.unassigned = null;
    }

    public emptySearch() {
        this.service = {
            serviceCode: null,
            userName: null,
            cleanerName: null,
            clientName: null,
            phoneContactPerson: null,
            emailContactPerson: null,
            streetName: null,
            address: null,
            dateIni: null,
            dateEnd: null,
        };
    }

    ngOnChanges(changes: any) {
        //console.log(changes);
        if(changes.cleanFilter && !changes.cleanFilter.firstChange){
            this.emptyFilters();
        }

        if(changes.search && changes.search.previousValue != null){
            if(changes.search.currentValue == null) this.emptySearch();
        }
    }


    ngOnInit() {
        this.dateFrom.dt = moment().subtract(15, 'days').toDate();
        this.dateSince.dt = moment().add(21, 'days').toDate();
        this.offices = getFiltersOffice();
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/search-services.component.ts